import React from "react";
import { Film, Tv, User } from "react-feather";

export const str_limit = (text, count) => {
  return text.slice(0, count) + (text.length > count ? "..." : "");
};

export const image = ({ image, w = 400, h = 600, type = "person" }) => {
  let _image = null;
  let url_base = `https://image.tmdb.org/t/p/w${w}_and_h${h}_`;
  let _type = type === "person" ? "face" : "bestv2";

  if (typeof image === "object") {
    if (image.profile_path) _image = url_base + _type + image.profile_path;
    if (image.poster_path) _image = url_base + _type + image.poster_path;
  }

  return _image;
};

export const icon = s => {
  let color = "black";
  let size = 20;
  let icon;

  if (s === "tv") icon = <Tv color={color} size={size} />;
  else if (s === "movie") icon = <Film color={color} size={size} />;
  else icon = <User color={color} size={size} />;

  return icon;
};

export const formatSearchDescription = s => {
  if (s.media_type === "person") {
    let e = [];
    s.known_for.map(_ => e.push(_.name || _.title));
    return `Best known for: ${e.join(", ")}`;
  } else return s.overview;
};

export const seasonEpisodeDisplay = episode => {
  let en = episode.episode_number;
  let sn = episode.season_number;

  if (en < 10) en = `0${en}`;
  if (sn < 10) sn = `0${sn}`;

  return `S${sn}E${en}`;
};



// WEBPACK FOOTER //
// ./src/helpers.js